import React, { useState } from 'react';
import {
  Accordion,
  Embed,
  Header,
  Icon,
  Image,
  Message,
} from 'semantic-ui-react';

const Install = ({ user }) => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <React.Fragment>
      <Header as='h2' inverted>Install</Header>
      <p>
        Installation of the Twitching of Isaac is really straight forward, however it is important to follow all of the steps below to
        ensure it works as intended. While there are multiple steps involved, the installation should take less than 5 minutes.
      </p>
      <p>
        Follow the following steps to install the mod:
      </p>
      <p>
        <ol>
          <li>Subscribe to the mod in the Steam Workshop by clicking <a href='https://steamcommunity.com/sharedfiles/filedetails/?id=2493976911'>this link</a>.</li>
          <li>Configure Isaac to allow networking by enabling lua debug mode:</li>
          <ol type='a'>
            <li>In your Steam Library, right click on Isaac, and select properties.</li>
            <li>On the properties screen, enter <strong>--luadebug</strong> in the Launch Options input.</li>
            <li>Close the properties window.</li>
          </ol>
          <Accordion inverted>
            <Accordion.Title
              active={showVideo}
              onClick={() => setShowVideo(showVideo => !showVideo)}
            >
              <Icon name='dropdown' />
              See video showing the lua debug steps
            </Accordion.Title>
            <Accordion.Content active={showVideo}>
              <Embed id='BPevJvf8e-w' source='youtube' active={true} defaultActive={true} />
            </Accordion.Content>
          </Accordion>
          <li>Start up Isaac, and the mod will be automatically downloaded.</li>
          <li>On your first run of the game with the mod enabled, the Twitching of Isaac menu should automatically open -- if it does not, you can access it via the <strong>F8</strong> key.</li>
          <li>Select the menu item <strong>Connect To Twitch</strong>.</li>
          <li>Click the button to open an activation screen on this website. If you are already logged in, activation will happen automatically, if not, you will need to login via Twitch.</li>
          <li>Once you have activated the mod, you will be returned to the main menu screen.  If the main screen now says you are connected, everything has worked as expected! The bot will auto-join your channel whenever you start the game with the mod enabled.</li>
        </ol>
      </p>
      <Header as='h3' inverted>Some Things you Should Know!</Header>
      <Message negative>
        <Message.Header>Unlocks and Achievements</Message.Header>
        <p>
          The Twitching of Isaac allows chat to interact with the game in a way that can cause you to either unlock items or characters, and gain achievements. It is also recommended
          that you use an alternate save file to prevent unlocks -- achievements however will still be possible.
        </p>
        <Message.Header>Risks of --luadebug</Message.Header>
        <p>
          The <strong>--luadebug</strong> parameter passed to Isaac, allows mods to operate in debug mode. In this mode, mods have additional functionality that is normally locked by
          the modding API. The Twitching of Isaac mod requires internet connectivity to work, as it interacts with the main server, and provides a bridge to Twitch. You need to be
          aware that enabling luadebug also gives mods unrestricted access to your file system and internet -- it will enable this functionality for ALL mods you have installed.
          There is a risk in enabling this mode, and a malicious mod could leverage this functionality to cause your system harm.
        </p>
        <p>
          Please only enable luadebug if you trust the mods installed on your machine, INCLUDING TWITCHING OF ISAAC. As a precaution, it is recommended to disable other mods to limit
          your risk while playing with Twitching of Isaac. Additionally, you should disable luadebug (by removing that flag from the paramaters screen) when you are not using Twitching
          of Isaac.
        </p>
      </Message>
      <Header as='h3' inverted>Troubleshooting</Header>
      <p>
        In the event that you make a mistake during the <strong>--luadebug</strong> step, you will see the following screen.
      </p>
      <Image src='/images/support_luadebug.png' />
      <br />
      <p>
        The main thing to note during this step is that there are <strong>2</strong> hyphens in front of luadebug. Please see the video above in the steps to see where to
        find the input area for this command.
      </p>
    </React.Fragment>
  )
};

export default Install;
